import apiSheet from '@/services/api/sheet';
import furtherStory from '@/services/api/furtherStory';

import { getField, updateField } from 'vuex-map-fields';
import fieldRemover from '@/utils/fieldsRemover';
import cloneDeep from 'lodash.clonedeep';
import merge from 'lodash.merge';

const defaultNote = () => {
    return {
        agenda: null,
        date: null,
        description: null,
        impression: null
    };
};

const defaultSummary = () => {
    return {
        ending_reason: null,
        ending_reason_explanation: null,
        description: null
    };
};

export default {
    namespaced: true,
    state: {
        resource: null,
        questions: null,
        note: defaultNote(),
        summary: defaultSummary()
    },
    getters: {
        getQuestions: (state) => state.questions,
        getResource: (state) => state.resource,
        getNoteData (state) {
            return getField(state.note);
        },
        getSummaryData (state) {
            return getField(state.summary);
        }
    },
    mutations: {
        setQuestions (state, data) {
            state.questions = data;
        },
        setResource (state, data) {
            state.resource = data;
        },
        updateNoteData (state, field) {
            updateField(state.note, field);
        },
        setNoteFields (state, data) {
            state.note = merge(state.note, data);
        },
        updateSummaryData (state, field) {
            updateField(state.summary, field);
        },
        setSummaryFields (state, data) {
            state.note = merge(state.summary, data);
        }
    },
    actions: {
        loadPage (context, payload) {
            context
                .dispatch(
                    'family/getFamily',
                    {
                        id: payload.familyId,
                        endpointLabel: 'family'
                    },
                    { root: true }
                )
                .then(({ data }) => {
                    payload.editionName = data.edition.name;
                    if (payload.type === 'note') {
                        context.dispatch('loadResource', payload);
                        if (payload.noteId) {
                            const familyNote = data.meeting_notes.find((el) => {
                                return el.id === payload.noteId;
                            });
                            const note = {};
                            Object.keys(familyNote)
                                .filter((key) => key in context.state.note)
                                .forEach((key) => {
                                    if (key === 'date') {
                                        note[key] = familyNote[key].replace(/([T].*)/, '');
                                    } else if (key === 'agenda') {
                                        note[key] = familyNote[key].id;
                                    } else {
                                        note[key] = familyNote[key];
                                    }
                                });
                            context.commit('setNoteFields', note);
                        }
                    }
                    if (payload.type === 'summary') {
                        context.dispatch('loadResource', payload);
                        if (data.meetings_summary != null) {
                            const familySummary = data.meetings_summary;
                            const summary = {};

                            Object.keys(familySummary)
                                .filter((key) => key in context.state.summary)
                                .forEach((key) => {
                                    if (key === 'ending_reason') {
                                        summary[key] = familySummary[key].map((arr) => {
                                            return arr.id;
                                        });
                                    } else {
                                        summary[key] = familySummary[key];
                                    }
                                });
                            context.commit('setSummaryFields', summary);
                        }
                    }
                });
        },
        loadResource (context, payload) {
            return apiSheet.getResourceSheet(payload.resourceId, payload.editionName).then(({ data }) => {
                if (payload.type === 'note') {
                    context.commit('setQuestions', data.data.sheet_questions[0].further_story.note);
                }
                if (payload.type === 'summary') {
                    context.commit(
                        'setQuestions',
                        data.data.sheet_questions[0].further_story.meetings_summary
                    );
                }
                context.commit('setResource', data.data.sheet_resource);
            });
        },
        saveData (context, payload) {
            const json = cloneDeep(context.state[payload.type]);
            fieldRemover(json);
            if (payload.type === 'summary') {
                return furtherStory.postSummary(payload.familyId, json);
            }
            return furtherStory.postNote(payload.familyId, json);
        },
        updateData (context, payload) {
            const json = cloneDeep(context.state[payload.type]);
            fieldRemover(json);
            return furtherStory.putNote(payload.familyId, payload.noteId, json);
        },
        deleteNote (context, payload) {
            return furtherStory.deleteNote(payload.familyId, payload.noteId).then(() => {
                const family = context.rootGetters['family/getFamily'];
                family.meeting_notes = family.meeting_notes.filter((el) => {
                    return el.id !== payload.noteId;
                });
                context.commit('family/setFamily', family, { root: true });
            });
        },
        clear (context) {
            context.state.note = defaultNote();
            context.state.summary = defaultSummary();
            context.state.resource = null;
            context.state.questions = null;
        }
    }
};
